import { render, staticRenderFns } from "./IndustrialIot.vue?vue&type=template&id=8ea08624&scoped=true"
import script from "./IndustrialIot.vue?vue&type=script&lang=js"
export * from "./IndustrialIot.vue?vue&type=script&lang=js"
import style0 from "./IndustrialIot.vue?vue&type=style&index=0&id=8ea08624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea08624",
  null
  
)

export default component.exports